import { ca } from '@cian/analytics';

import { IPage } from './common';

export const trackingPageType = 'Subscription';
export const category = 'Unsubscription';

export interface ITrackDeleteSubspriptionParams {
  label: string;
  page: IPage;
}

/**
 * Используется для событий удаления подписок и выключения блогов (это исключение)
 * @param {string} label
 * @param {IPage} page
 */
export function trackSubscriptionDelete({ label, page }: ITrackDeleteSubspriptionParams) {
  ca('event', {
    action: 'Send',
    category,
    label,
    name: 'oldevent',
    page,
  });
}
